import { PARTNER_STORAGE_KEY } from "@kovernow/flows/auth";

/** Per-tab partner code from `/p/<code>` (sessionStorage; not a secret). */
export const partnerStorage = {
  get(): string | null {
    try {
      return window.sessionStorage.getItem(PARTNER_STORAGE_KEY);
    } catch {
      return null;
    }
  },
  set(code: string) {
    try {
      window.sessionStorage.setItem(PARTNER_STORAGE_KEY, code);
    } catch {
      // Storage blocked: the code just isn't carried to sign-up.
    }
  },
  clear() {
    try {
      window.sessionStorage.removeItem(PARTNER_STORAGE_KEY);
    } catch {
      // ignore
    }
  },
};
